import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import axios from 'axios'
import App from '~/components/App'
import BootstrapVue from 'bootstrap-vue'
import FileManager from 'laravel-file-manager'
import moment from 'moment'
import vueAwesomeCountdown from 'vue-awesome-countdown'

import '~/plugins'
import '~/components'

Vue.filter('formatYmd', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD')
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format('DD.MM.YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(value).format('DD.MM.YYYY HH:mm')
  }
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(value).format('HH:mm')
  }
})

Vue.use(BootstrapVue)
Vue.use(FileManager, { store })
Vue.use(vueAwesomeCountdown, 'countdown')

Vue.prototype.$axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})
